// Tax maths shared by the storefront cart/checkout and the POS (the server uses the same rules: backend/taxes.py).
//   exclusive price: tax = line × rate%, ADDED on top of the price
//   inclusive price: tax = line × rate / (100 + rate), already INSIDE the price (shown, not added)
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function lineTax({ price, qty, rate, inclusive }) {
  const line = round2((Number(price) || 0) * (Number(qty) || 0));
  const r = Number(rate) || 0;
  const tax = !r ? 0 : round2(inclusive ? (line * r) / (100 + r) : (line * r) / 100);
  return { line, tax, rate: r, inclusive: !!inclusive, added: inclusive ? 0 : tax, total: round2(line + (inclusive ? 0 : tax)) };
}

/** Tax of a storefront cart item, using the store's CURRENT rule for the product (category tax from Setup) when known. */
export function cartItemTax(item, products = []) {
  const p = products.find((x) => x.id === item.product_id);
  const rate = Number(p?.tax_rate ?? item.tax_rate) || 0;
  const type = p?.tax_type ?? item.tax_type ?? "";
  const inclusive = !!(p ? p.tax_inclusive : item.tax_inclusive);
  return { ...lineTax({ price: item.price, qty: item.quantity, rate, inclusive }), type };
}

/** Totals over many lines: subtotal (item prices), tax added to the total, tax already included, label (GST / VAT / GST + VAT / Tax). */
export function sumTax(lines) {
  const types = [...new Set(lines.filter((l) => l.tax > 0 && l.type).map((l) => l.type))].sort();
  return {
    subtotal: round2(lines.reduce((n, l) => n + l.line, 0)),
    added: round2(lines.reduce((n, l) => n + l.added, 0)),
    included: round2(lines.reduce((n, l) => n + (l.inclusive ? l.tax : 0), 0)),
    label: types.length ? types.join(" + ") : "Tax",
  };
}
